/**
 * @deprecated
 */
import { type SticksMatrix } from "@jti/fe-common";
import { useQuery } from "@jti/rest-api";

import { magento } from "../../clients/getClient";

export const useSticksMatrix = () => useQuery<SticksMatrix>("GET_STICKS_MATRIX", () => magento.getSticksMatrix());
